import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Wrapper, Background, Icon } from './styled';
function UpsellBackground({ background, icon }) {
    return (_jsx(Wrapper, { children: _jsxs(Background, { children: [icon && _jsx(Icon, { src: icon, alt: "" }), _jsx("img", { src: background, alt: "" })] }) }));
}
export default UpsellBackground;
